var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#DCE6EC",
    stroke: "#D1DCE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 7.33329C12.8097 7.33329 12.0679 7.64058 11.5209 8.18756C10.9739 8.73455 10.6666 9.47641 10.6666 10.25C10.6666 11.0235 10.9739 11.7654 11.5209 12.3124C12.0679 12.8593 12.8097 13.1666 13.5833 13.1666C14.3568 13.1666 15.0987 12.8593 15.6457 12.3124C16.1927 11.7654 16.5 11.0235 16.5 10.25C16.5 9.47641 16.1927 8.73455 15.6457 8.18756C15.0987 7.64058 14.3568 7.33329 13.5833 7.33329ZM8.99996 10.25C8.99996 9.03438 9.48284 7.86859 10.3424 7.00905C11.2019 6.14951 12.3677 5.66663 13.5833 5.66663C14.7989 5.66663 15.9647 6.14951 16.8242 7.00905C17.6837 7.86859 18.1666 9.03438 18.1666 10.25C18.1666 11.4655 17.6837 12.6313 16.8242 13.4909C15.9647 14.3504 14.7989 14.8333 13.5833 14.8333C12.3677 14.8333 11.2019 14.3504 10.3424 13.4909C9.48284 12.6313 8.99996 11.4655 8.99996 10.25ZM19 15.6666C18.225 15.6666 17.75 16.2133 17.75 16.7075V17.5408H16.0833V16.7075C16.0833 15.1316 17.475 14 19 14C20.525 14 21.9166 15.1316 21.9166 16.7075C21.9145 17.0688 21.8373 17.4257 21.69 17.7557C21.5427 18.0856 21.3284 18.3814 21.0608 18.6241L19.8333 19.7825V20.3516H18.1666V19.0633L19.9266 17.4025C20.14 17.2066 20.25 16.9608 20.25 16.7075C20.25 16.2133 19.775 15.6666 19 15.6666ZM10.6666 17.3333C9.78257 17.3333 8.93472 17.6845 8.3096 18.3096C7.68448 18.9347 7.33329 19.7826 7.33329 20.6666H14.6666V22.3333H5.66663V20.6666C5.66663 19.3405 6.19341 18.0688 7.13109 17.1311C8.06877 16.1934 9.34054 15.6666 10.6666 15.6666H14.625V17.3333H10.6666ZM18.1666 21.4966H19.8358V23.1666H18.1658L18.1666 21.4966Z",
    fill: "#87A4B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassigned);
export default __webpack_public_path__ + "static/media/unassigned.1c8d01771c06612c125a7030609b84c0.svg";
export { ForwardRef as ReactComponent };